<app-left-side></app-left-side>
<app-right-side></app-right-side>
<app-header></app-header>
<h1 class="text-center"  [dir]="direction"> History  !!! Comming Soon </h1>